module.exports = __webpack_public_path__ + "static/img/19鼎尖.81cf64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/19鼎尖.jpg
// module id = xWqz
// module chunks = 1